import type { Node } from '@xyflow/react';
import type { BaseNodeData } from '../types';
import { isBehaviorSwitchStepType } from './stepValidationUtils';

export const BEHAVIOR_SWITCH_LAST_STEP_MESSAGE =
	'Conditional Behavior must be the last step in this path. Add follow-up steps inside one of its branches.';

export function isBehaviorSwitchNodeInTemplate(node: Node<BaseNodeData>, templateId: string): boolean {
	const nodeData = node.data as { automationStep?: { _type?: unknown }; automationTemplate?: { id?: string } };
	return nodeData.automationTemplate?.id === templateId && isBehaviorSwitchStepType(nodeData.automationStep?._type);
}

/**
 * Reads the canvas instead of template query data: the canvas reflects optimistic adds and
 * removals at once, while the query keeps a removed Conditional Behavior until the next refetch.
 */
export function templateHasBehaviorSwitch(nodes: Node<BaseNodeData>[], templateId: string): boolean {
	return nodes.some(node => isBehaviorSwitchNodeInTemplate(node, templateId));
}
